import $ from 'jquery';
import { toParamString } from '../utils';

// 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
const basicCode = {
  "s": "IM",
  "a": "IMTO",
  "dc": "IIM"
};

function sendClickLog(targetElem, params, event, extra, isBasic = true) {
  const paramsMerged = isBasic ? $.extend({}, basicCode, params) : $.extend({}, params);
  window.smartLog(targetElem, toParamString(paramsMerged), event, extra);
}

function sendFreeLog(paramArgs) {
  const freeLogUrl = `https:${window.SEARCHLOGDOMAIN}/fr/imgviewer/p?vle=`;
  const params = $.extend({
    rclk: 1,
    q: window.utf8Query,
    mk: window.mk || null,
    ud: window.ud || null,
    device: 'pc',
  }, paramArgs);

  const reqUrl = `${freeLogUrl}${encodeURIComponent(toParamString(params))}`;
  $.cachedScript(reqUrl);
}

function setBasicCode(key, value) {
  basicCode[key] = value;
}

export default {
  sendClickLog,
  sendFreeLog,
  setBasicCode
};


/** WEBPACK FOOTER **
 ** ./src/IIM/core/logger/index.js
 **/